import React from "react";
import coinIcon from "../../../../assets/images/iconsRoles/coinIcon.svg";

const ComissionsStatus = ({ commissions }) => {
  return (
    <>
      <div className="col-12 d-flex flex-row align-items-center">
        <div className="d-flex align-items-center mb-3">
          <img
            src={coinIcon}
            alt="invocesIcon"
            className="me-2 ps-1"
            style={{ width: "30px" }}
          />
          <h2 className="mb-0">Commissions Status</h2>
        </div>
      </div>
      <div className="col-12">
        <div className="table-responsive">
          <table className="table table-centered table-nowrap mb-0">
            <thead className="bg" style={{ background: "var(--thead-bg)" }}>
              <tr>
                <th>Commission ID</th>
                <th>Employer ID</th>
                <th>Due Date</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {commissions?.map((commission) => (
                <tr key={commission.id}>
                  <td>{commission.id}</td>
                  <td>{commission.employer_id}</td>
                  <td>{commission.due_date}</td>
                  <td>{commission.amount}</td>
                  <td>{commission.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ComissionsStatus;
